import { Injectable } from '@angular/core';
import { Action, select, Store } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import * as fromAuth from './auth.reducer';
import * as AuthSelectors from './auth.selectors';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  user$ = this.store.pipe(select(AuthSelectors.selectUser));
  userPermissions$ = this.store.pipe(
    select(AuthSelectors.selectUserPermissions)
  );
  publicTokens$ = this.store.pipe(select(AuthSelectors.selectPublicTokens));
  isLoadingUser$ = this.store.pipe(select(AuthSelectors.selectIsLoadingUser));
  isLoadingPublicTokens$ = this.store.pipe(
    select(AuthSelectors.selectIsLoadingPublicTokens)
  );
  isLoadingOUVLayers$ = this.store.pipe(
    select(AuthSelectors.selectIsLoadingOUVLayers)
  );
  error$ = this.store.pipe(select(AuthSelectors.selectAuthError));

  constructor(private store: Store<fromAuth.State>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  logout() {
    this.dispatch(AuthActions.userLogout());
  }

  getPublicTokens(subdomain: string) {
    this.dispatch(AuthActions.getPublicTokens({ subdomain }));
  }
}
